import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_API_URL } from "../../utils/constants";

const LearnersDetailsContent = () => {
    const [learners, setLearners] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedBU, setSelectedBU] = useState("");
    const [searchEnterpriseId, setSearchEnterpriseId] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10;

    useEffect(() => {
        getLearnersReport();
    }, []);

    useEffect(() => {
        setCurrentPage(1);
    }, [selectedBU, searchEnterpriseId]);

    const getLearnersReport = async () => {
        try {
            setLoading(true);

            const { data } = await axios.get(`${ BASE_API_URL }/learnersDetails`);
            // const { data } = await axios.get("http://localhost:5000/learnersDetails");

            setLearners(data || []);

            if (data?.length > 0) {
                const uniqueBusinessUnits = [
                    ...new Set(
                        data
                            .map((item) => item.businessUnit)
                            .filter(Boolean)
                    ),
                ];

                if (uniqueBusinessUnits.length > 0) {
                    setSelectedBU(uniqueBusinessUnits[0]);
                }
            }
        } catch (error) {
            console.error("Error fetching learners report:", error);
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (date) => {
        if (!date) return "-";

        return new Date(date).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    const businessUnits = [
        ...new Set(
            learners
                .map((item) => item.businessUnit)
                .filter(Boolean)
        ),
    ];

    const filteredLearners = learners.filter((item) => {
        const matchesBU = selectedBU
            ? item.businessUnit?.toLowerCase() ===
            selectedBU.toLowerCase()
            : true;

        const matchesEnterpriseId =
            !searchEnterpriseId ||
            item.enterpriseId
                ?.toLowerCase()
                .includes(searchEnterpriseId.toLowerCase());

        return matchesBU && matchesEnterpriseId;
    });

    const totalPages = Math.ceil(filteredLearners.length / rowsPerPage);

    const paginatedLearners = filteredLearners.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    return (
        <div
            style={{
                padding: "20px",
                overflowX: "auto",
            }}
        >
            {/* Business Unit Tabs */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                    flexWrap: "wrap",
                    gap: "12px",
                }}
            >
                {/* Left Side Tabs */}
                <div
                    style={{
                        display: "flex",
                        gap: "12px",
                        overflowX: "auto",
                        flexWrap: "nowrap",
                        maxWidth: "calc(100% - 320px)",
                        scrollbarWidth: "thin",
                    }}
                >
                    {businessUnits.map((bu) => {
                        const isActive =
                            selectedBU?.toLowerCase() === bu?.toLowerCase();

                        return (
                            <button
                                key={bu}
                                onClick={() => setSelectedBU(bu)}
                                style={{
                                    padding: "10px 24px",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    fontWeight: 600,
                                    fontSize: "14px",
                                    whiteSpace: "nowrap",
                                    background: isActive
                                        ? "linear-gradient(90deg, #7500c0 0%, #7c0adf 100%)"
                                        : "#e5e5e5",
                                    color: isActive ? "#fff" : "#333",
                                }}
                            >
                                {`${bu} (${learners.filter(
                                    (item) =>
                                        item.businessUnit?.toLowerCase() ===
                                        bu.toLowerCase()
                                ).length
                                    })`}
                            </button>
                        );
                    })}
                </div>

                {/* Right Side Search */}
                <div
                    style={{
                        position: "relative",
                        width: "300px",
                    }}
                >
                    <input
                        type="text"
                        placeholder="Search by Enterprise ID..."
                        value={searchEnterpriseId}
                        onChange={(e) => setSearchEnterpriseId(e.target.value)}
                        style={{
                            width: "100%",
                            padding: "10px 40px 10px 14px",
                            border: "1px solid rgb(70, 0, 115)",
                            borderRadius: "6px",
                            fontSize: "14px",
                            outline: "none",
                        }}
                    />

                    <img
                        src={
                            process.env.PUBLIC_URL +
                            "/Assets/UserMaintenance/search-icon.png"
                        }
                        alt="search"
                        style={{
                            position: "absolute",
                            right: "12px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: "20px",
                            height: "20px",
                            pointerEvents: "none",
                        }}
                    />
                </div>
            </div>

            {loading ? (
                <div
                    style={{
                        textAlign: "center",
                        padding: "30px",
                        fontSize: "16px",
                        fontWeight: 600,
                    }}
                >
                    Loading...
                </div>
            ) : (
                <>
                    <table
                        style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            minWidth: "1200px",
                            borderRadius: "8px",
                            overflow: "hidden",
                        }}
                    >
                        <thead>
                            <tr
                                style={{
                                    background:
                                        "linear-gradient(90deg, #7500c0 0%, #7c0adf 100%)",
                                    color: "#fff",
                                }}
                            >
                                <th style={headerStyle}>SI#</th>
                                <th style={headerStyle}>Course Code</th>
                                <th style={headerStyle}>Course Name</th>
                                <th style={headerStyle}>Enterprise ID</th>
                                <th style={headerStyle}>Course Completion Date</th>
                                <th style={headerStyle}>Course Enrollment Date</th>
                            </tr>
                        </thead>

                        <tbody>
                            {filteredLearners?.length > 0 ? (
                                paginatedLearners.map((item, index) => (
                                    <tr
                                        key={item.id}
                                        style={{
                                            backgroundColor:
                                                ((currentPage - 1) * rowsPerPage + index) %
                                                    2 ===
                                                    0
                                                    ? "#f4f4f4"
                                                    : "#ece8ef",
                                        }}
                                    >
                                        <td style={cellStyle}>{item.id}</td>
                                        <td style={cellStyle}>
                                            {item.courseCode || "-"}
                                        </td>
                                        <td style={cellStyle}>
                                            {item.courseName || "-"}
                                        </td>
                                        <td style={cellStyle}>
                                            {item.enterpriseId || "-"}
                                        </td>
                                        <td style={cellStyle}>
                                            {formatDate(item.completionDate)}
                                        </td>
                                        <td style={cellStyle}>
                                            {formatDate(item.enrollmentDate)}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan={6}
                                        style={{
                                            textAlign: "center",
                                            padding: "20px",
                                            fontWeight: 600,
                                        }}
                                    >
                                        No {selectedBU} learner records found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    {/* Pagination */}
                    {filteredLearners.length > 0 && totalPages > 1 && (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "12px",
                                marginTop: "20px",
                            }}
                        >
                            <button
                                onClick={() =>
                                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                                }
                                disabled={currentPage === 1}
                                style={{
                                    padding: "8px 16px",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor:
                                        currentPage === 1
                                            ? "not-allowed"
                                            : "pointer",
                                    background:
                                        currentPage === 1
                                            ? "#ccc"
                                            : "linear-gradient(90deg, #7500c0 0%, #7c0adf 100%)",
                                    color: "#fff",
                                }}
                            >
                                Previous
                            </button>

                            <span
                                style={{
                                    fontSize: "14px",
                                    fontWeight: 600,
                                }}
                            >
                                Page {currentPage} of {totalPages}
                            </span>

                            <button
                                onClick={() =>
                                    setCurrentPage((prev) =>
                                        Math.min(prev + 1, totalPages)
                                    )
                                }
                                disabled={currentPage === totalPages}
                                style={{
                                    padding: "8px 16px",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor:
                                        currentPage === totalPages
                                            ? "not-allowed"
                                            : "pointer",
                                    background:
                                        currentPage === totalPages
                                            ? "#ccc"
                                            : "linear-gradient(90deg, #7500c0 0%, #7c0adf 100%)",
                                    color: "#fff",
                                }}
                            >
                                Next
                            </button>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

const headerStyle = {
    padding: "18px 16px",
    textAlign: "left",
    fontSize: "15px",
    fontWeight: "600",
    borderBottom: "1px solid #ddd",
};

const cellStyle = {
    padding: "14px 16px",
    textAlign: "left",
    borderBottom: "1px solid #d6d6d6",
    fontSize: "14px",
    color: "#333",
};

export default LearnersDetailsContent;